'use strict';

import angular from "angular";
import "./auth/auth";
import "../common/utils";
import "../common/Token";

// Declare app level module which depends on views, and components
export default angular.module('fastx.ssh', [
  'fastx.utils',
  'fastx.auth',
  'Token'
]).
run(['Version','$rootScope','Token','$location',function(Version,$rootScope,Token,$location){
	Token.remove();
	Version(function(m){
		$rootScope.version = m.version;
	});

	$rootScope.hideLogo = $location.search().hideLogo;
}])
.controller('VersionCtrl',['$scope','Version','$window',function($scope,Version,$window){
	$scope.version ='';
	Version(function(msg){
		$scope.version = msg.version;

	});
}])
.factory('BrowserSupport',['$window',function($window){
	var o = {};
	if($window.ArrayBuffer && window.ArrayBuffer && $window.Worker && window.localStorage && $window.WebSocket && $window.Promise){
		o.fastx = true;
	}
	if(window.SIMD){
		o.SIMD = true;
	}
	return o;
}]);
angular.bootstrap(document, ['fastx.ssh']);



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 7
// module chunks = 0